/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 * API Request Tracker - Tracks pending API calls to prevent interruption
 */

class ApiRequestTracker {
  private pendingRequests = 0;
  private listeners = new Set<() => void>();

  startRequest() {
    this.pendingRequests++;
    console.log(`[ApiTracker] Request started. Pending: ${this.pendingRequests}`);
    this.notifyListeners();
  }

  endRequest() {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    console.log(`[ApiTracker] Request ended. Pending: ${this.pendingRequests}`);
    this.notifyListeners();
  }

  hasPendingRequests(): boolean {
    return this.pendingRequests > 0;
  }

  getPendingCount(): number {
    return this.pendingRequests;
  }

  onChange(listener: () => void) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  private notifyListeners() {
    this.listeners.forEach(listener => listener());
  }

  reset() {
    this.pendingRequests = 0;
    this.notifyListeners();
  }
}

export const apiTracker = new ApiRequestTracker();
